<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from "ant-design-vue/es/locale/zh_CN";
export default {
  name: "App",
  data() {
    return {
      locale: zhCN
    };
  },
};
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  padding: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: rgb(210, 227, 229);
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background: rgb(255, 255, 255);
  border-radius: 5px;
  box-shadow: 0 0 1px 1px rgb(210, 227, 229, 0.6) inset;
}
.ant-popover {
  width: 280px;
  right: 432px !important;
  left: inherit !important;
}
.ant-popover-title {
  border-bottom: none;
  color: rgb(0, 138, 143);
  font-size: 14px;
  line-height: 42px;
}
.ant-popover-inner-content {
  height: 220px;
  overflow-y: scroll;
}
.ant-popover-inner-content::-webkit-scrollbar {
  width: 0;
}
.newsItem {
  color: rgb(0, 0, 0);
  cursor: pointer;
}
.ant-divider-horizontal.ant-divider-with-text-right::before {
  border-top: 1px dashed rgba(165, 165, 165, 0.3);
}
.ant-divider-horizontal.ant-divider-with-text-right {
  margin: 0 0 10px;
}
.ant-divider-inner-text {
  color: rgb(51, 51, 51);
  font-size: 12px;
}
.ant-modal-header {
  border-bottom: none;
}
.ant-modal-title,
.ant-modal-close {
  color: rgb(0, 138, 143);
}
.ant-modal-close-x {
  font-size: 14px;
}
.modalTitle {
  color: rgb(0, 0, 0);
  text-align: center;
  font-weight: 500;
}
.modalContent {
  color: rgb(51, 51, 51);
  line-height: 24px;
  margin: 24px 0 10px;
  text-indent: 2em;
}
.ant-drawer-body {
  height: calc(100vh - 60px);
  overflow-y: scroll;
}
</style>
